import { CalendarPlus, Sparkles, MapPin } from "lucide-react";
import { useTrip, useUI } from "@/lib/store";
import { TRIP_DATES } from "@/lib/dates";
import { BottomSheet } from "./BottomSheet";

export function QuickAddSheet() {
  const { quickAdd, closeQuickAdd, openEditor, openIdeaEditor } = useUI();
  const { today } = useTrip();
  const date = TRIP_DATES.includes(today) ? today : TRIP_DATES[0];
  const OPTIONS = [
    { id: "event", label: "Event", sub: "Something on a day of the trip", Icon: CalendarPlus, run: () => openEditor({ mode: "add", date }) },
    { id: "idea", label: "Idea", sub: "A wish-list item for a city", Icon: Sparkles, run: () => openIdeaEditor({}) },
    { id: "place", label: "Place", sub: "A restaurant or sight — paste a link or address", Icon: MapPin, run: () => openIdeaEditor({ place: true }) },
  ];
  return (
    <BottomSheet open={quickAdd} onClose={closeQuickAdd} testId="quick-add-sheet" eyebrow="Add to the trip" title="What would you like to add?">
      <div className="mt-4 space-y-2">
        {OPTIONS.map((o) => (
          <button key={o.id} data-testid={`quick-add-${o.id}`} onClick={() => { closeQuickAdd(); setTimeout(o.run, 120); }} className="tap card-soft flex w-full items-center gap-4 p-4 text-left">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[var(--jade)] text-[var(--parchment)]"><o.Icon className="h-5 w-5" /></span>
            <span><span className="block font-display text-xl font-semibold">{o.label}</span><span className="block text-xs text-[var(--ink-muted)]">{o.sub}</span></span>
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}
